import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "user-table" }
const _hoisted_5 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "#"),
    /*#__PURE__*/_createVNode("th", { width: "70%" }, "Заголовок"),
    /*#__PURE__*/_createVNode("th", null, "Операции")
  ])
], -1)
const _hoisted_6 = { class: "user-edit" }
const _hoisted_7 = { class: "news-edit" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_admin_import = _resolveComponent("admin-import")
  const _component_Downloaded = _resolveComponent("Downloaded")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_main_footer = _resolveComponent("main-footer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_admin_import),
    (!_ctx.endpending)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("table", _hoisted_4, [
            _hoisted_5,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinsStatGov, (bulletinStatGov) => {
                return (_openBlock(), _createBlock("tr", {
                  key: bulletinStatGov.id
                }, [
                  _createVNode("td", null, _toDisplayString(bulletinStatGov.id), 1),
                  _createVNode("td", null, _toDisplayString(bulletinStatGov.Name), 1),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        _createVNode(_component_svg_icon, { name: "uploadfile" }),
                        _createVNode("p", {
                          onClick: $event => (
                        _ctx.setBulletinStatGov(
                          bulletinStatGov.id,
                          bulletinStatGov.Name
                        )
                      )
                        }, " выбрать ", 8, ["onClick"])
                      ])
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_main_footer)
  ], 64 /* STABLE_FRAGMENT */))
}